<script lang="ts">
  import { setContext, untrack } from 'svelte'
  import type { HTMLAttributes } from 'svelte/elements'
  import { writable } from 'svelte/store'
  import { panesStore } from '../../stores/panes'

  type Props = HTMLAttributes<HTMLDivElement> & {
    disabled?: boolean
    defaultValue?: boolean
    key: string
  }

  let {
    children,
    disabled = false,
    defaultValue = false,
    key,
    ...rest
  }: Props = $props()

  let openStore = writable(false)
  let disabledStore = writable(false)

  setContext<PaneContext>('pane', { open: openStore, disabled: disabledStore })

  // Initialize from store or default
  $effect(() => {
    const storeValue = $panesStore[key]
    if (storeValue !== undefined) {
      untrack(() => openStore.set(storeValue))
    }
    else {
      untrack(() => openStore.set(defaultValue))
    }
  })

  // Sync local changes back to store
  $effect(() => {
    const currentOpen = $openStore
    untrack(() => {
      panesStore.update(store => ({
        ...store,
        [key]: currentOpen,
      }))
    })
  })

  // Update disabled state
  $effect(() => {
    disabledStore.set(disabled)
  })
</script>

<div {...rest}>{@render children?.()}</div>
